  $(document).on('click','button.btn.product__submit__add',function(){
  var id = $(this).parents('.grid__item').find('.variant_select option:selected').attr('data-id');
  if($(this).parents('.grid__item').find('.rtx-subscription').length > 0 && $(this).parents('.grid__item').find('.rtx-subscription input[value="purchaseTypeSubscription"]:checked').length > 0){
  var selling_plan_id =   $(this).parents('.grid__item').find('.rtx-subscription .rtx-subscription-dropdown option:selected').val();
  }
     if($(this).parents('.grid__item').find('.rtx-subscription').length > 0 && $(this).parents('.grid__item').find('.rtx-subscription input[value="purchaseTypeSubscription"]:checked').length > 0){
         var items = [{"id":id,"qty":1,'selling_plan': selling_plan_id}];
     }else{
         var items = [{"id":id,"qty":1}];
     }

$.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {items:items},
          dataType: 'json', 
         success: function(){
             window.location.href = '/cart';
         },
         error: function (data) {
       $(`<p class='error' style="margin:0px">${data.responseJSON['message']}</p>`).insertAfter('.select.no-js');
        setTimeout(function(){$('.error').remove();},5000);
        console.log(data);
      } 
  })  
})
$('.index-collection .variant_select').change(function () { 
    var sel_vp =   $(this).find('option:selected').attr('data-price');
    var cprice =   $(this).find('option:selected').attr('data-cprice');
    var product_avl = $(this).attr('data-available');
    if(product_avl == false){
    $(this).parents('.grid__item').find('button.btn.product__submit__add span').text('Sold Out').attr('disabled',true);
    }else{
    $(this).parents('.grid__item').find('button.btn.product__submit__add span').text('Add to Cart').attr('disabled',false);
    }
    var sub_per_off = '';
    if($(this).parents('.grid__item').find('.rtx-subscription').length > 0){
    var sub_per_off = $(this).parents('.grid__item').find('.rtx-subscription-dropdown option:selected').attr('data-percent');
    var cal_price = parseInt((sel_vp*sub_per_off)/100);
    cal_price = sel_vp - cal_price;
    }else{
    var cal_price =  sel_vp;
    }
    if(cprice != '' ){
    var cprice = slate.Currency.formatMoney(cprice, theme.moneyFormat);    
    }
     $(this).parents('.grid__item').find('.price_wrapper s').html(`${cprice}`);
    var price = slate.Currency.formatMoney(cal_price, theme.moneyFormat);
     var vprice = slate.Currency.formatMoney(sel_vp, theme.moneyFormat);
    $(this).parents('.grid__item').find('.price_wrapper .p_price').html(`${price}`);
    $(this).parents('.grid__item').find('span[data-rtx-onetime-price]').html(vprice);
    $(this).parents('.grid__item').find('span[data-rtx-subscription-price]').html(`${sub_per_off}% ${price}`);
})
  $('.index-collection .rtx-subscription-dropdown').change(function(){
   if($(this).parents('.grid__item').find('.rtx-subscription input[value="purchaseTypeSubscription"]:checked').length > 0 ){
    var percent =  $(this).find('option:selected').attr('data-percent');
    var price =  $(this).find('option:selected').attr('data-price-m'); 
    var selected_vp = $(this).parents('.grid__item').find('.variant_select option:selected').attr('data-price');
    var cal_price = parseInt((selected_vp*percent)/100);
    cal_price = selected_vp - cal_price;
    if(cprice != '' ){
    var cprice = slate.Currency.formatMoney(cprice, theme.moneyFormat);    
    }
    var price = slate.Currency.formatMoney(cal_price, theme.moneyFormat); 
    $(this).parents('.rtx-subscription').find('span[data-rtx-subscription-price]').html(`${percent}% ${price}`);
    $(this).parents('.grid__item').find('.subscription-badge').html(`Subscribe and Save ${percent}%`);
    $(this).parents('.grid__item').find('.price_wrapper .p_price').html(`${price}`);
   }
})
$('.index-collection .rtx-subscription-label').click(function(){
    if($(this).find('input[value="purchaseTypeOneTime"]').length > 0){
     var price = $(this).find('span[data-rtx-onetime-price]').html();
    }else if($(this).parents('.grid__item').find('.rtx-subscription input[value="purchaseTypeSubscription"]:checked').length > 0 ){
       var price = $(this).find('.rtx-subscription-dropdown option:selected').attr('data-price-m');
       var selected_vp = $(this).parents('.grid__item').find('.variant_select option:selected').attr('data-price');
      var sub_per_off = $(this).parents('.grid__item').find('.rtx-subscription-dropdown option:selected').attr('data-percent');
      var cal_price = parseInt((selected_vp*sub_per_off)/100);
      cal_price = selected_vp - cal_price;
      if(cprice != '' ){
      var cprice = slate.Currency.formatMoney(cprice, theme.moneyFormat);    
      }
      var price = slate.Currency.formatMoney(cal_price, theme.moneyFormat); 
      }
     
    $(this).parents('.grid__item').find('.price_wrapper .p_price').text(price);
})